/**
 * Firebase Auth helpers for Google (and Microsoft in dev).
 * Used by Login/Register to get an ID token, then exchanged for app JWT via /auth/oauth.
 */
import { getAuth, signInWithPopup, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { app } from "./firebase";

const auth = getAuth(app);

/** Sign in with Google; returns Firebase ID token or throws. */
export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();
  return idToken;
}

/** Sign in with Microsoft (for dev; UI hidden on live). Returns Firebase ID token or throws. */
export async function signInWithMicrosoft() {
  const provider = new OAuthProvider("microsoft.com");
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();
  return idToken;
}
